/*
 * rheincool — Kontaktseite (Kontakt-Produktberater-Handoff Teil 1)
 * - Verfügbarkeits-Indikator gegen Öffnungszeiten ("1-5:8-18,6:9-13") und
 *   Feiertagsliste (YYYY-MM-DD je Zeile); außerhalb kein grüner Punkt
 * - Anliegen-Kacheln routen die Betreffzeile (Wartung → Service, Gewerbe → Objektberatung)
 * - Segmente (Räume/Objekt) mit Miete-Hinweis; Rückruf-Pills erst nach Checkbox
 * - Erfolgszustand: Referenznummer + konkrete Rückmeldezeit
 */
(() => {
  'use strict';
  if (window.__rcContactPage) return;
  window.__rcContactPage = true;

  const track = (event, params) => {
    if (window.rcTrack) window.rcTrack(event, params || {});
  };

  /* ---------- Verfügbarkeit ---------- */

  const parseHours = (spec) => {
    // "1-5:8-18,6:9-13" → Map Wochentag → [von, bis]
    const map = {};
    (spec || '').split(',').forEach((part) => {
      const m = part.trim().match(/^(\d)(?:-(\d))?:(\d{1,2})-(\d{1,2})$/);
      if (!m) return;
      const from = parseInt(m[1], 10);
      const to = m[2] ? parseInt(m[2], 10) : from;
      for (let d = from; d <= to; d += 1) map[d] = [parseInt(m[3], 10), parseInt(m[4], 10)];
    });
    return map;
  };

  const isOpen = (hours, holidays, now) => {
    const iso = now.toISOString().slice(0, 10);
    if (holidays.includes(iso)) return false;
    const win = hours[now.getDay() === 0 ? 7 : now.getDay()];
    if (!win) return false;
    const h = now.getHours() + now.getMinutes() / 60;
    return h >= win[0] && h < win[1];
  };

  const availability = document.querySelector('[data-availability]');
  let hoursMap = {};
  let holidayList = [];
  if (availability) {
    hoursMap = parseHours(availability.dataset.hours);
    holidayList = (availability.dataset.holidays || '').split(/\s+/).filter(Boolean);
    const open = isOpen(hoursMap, holidayList, new Date());
    const dot = availability.querySelector('[data-availability-dot]');
    const text = availability.querySelector('[data-availability-text]');
    if (open) {
      dot.hidden = false;
      text.textContent = text.dataset.online || 'Jetzt erreichbar';
      availability.classList.add('is-open');
    }
  }

  /* ---------- Formular ---------- */

  const form = document.getElementById('ContactPageForm');
  if (form) {
    // Anliegen → Betreff-Routing
    const subject = form.querySelector('[data-topic-subject]');
    const routing = { wartung: 'Wartung (Service-Team)', gewerbe: 'Gewerbe (Objektberatung)', foerderung: 'Förder-Check' };
    form.querySelectorAll('[data-topic]').forEach((box) => {
      box.addEventListener('change', () => {
        const selected = Array.from(form.querySelectorAll('[data-topic]:checked'));
        const routed = selected.map((b) => routing[b.dataset.topic]).filter(Boolean);
        subject.value = routed[0] || (selected.length ? `Beratung: ${selected.map((b) => b.value).join(', ')}` : 'Beratung');
        track('contact_topic_select', { anliegen: selected.map((b) => b.value) });
      });
    });

    /*
     * Fotos (Handoff §1.4 Schritt 2). Shopifys Kontaktformular kann keine
     * Dateien uebertragen — ohne App gibt es dafuer keinen Weg. Die Auswahl
     * geht deshalb als Notiz mit ("3 Fotos vorbereitet: kueche.jpg, ..."),
     * damit das Team die Bilder gezielt anfordert; der WhatsApp-Knopf daneben
     * ist der Weg, der die Bilder sofort transportiert.
     */
    const fotoInput = form.querySelector('[data-photo-input]');
    if (fotoInput) {
      const liste = form.querySelector('[data-photo-list]');
      const wert = form.querySelector('[data-photo-value]');
      fotoInput.addEventListener('change', () => {
        const namen = Array.from(fotoInput.files || []).map((f) => f.name);
        if (liste) {
          liste.textContent = namen.join(' · ');
          liste.hidden = namen.length === 0;
        }
        if (wert) {
          wert.value = namen.length ? `${namen.length} Foto(s) vorbereitet: ${namen.join(', ')}` : '';
        }
      });
    }

    // Segmente (Räume / Objekt) inkl. Miete-Hinweis
    form.querySelectorAll('[data-segments]').forEach((group) => {
      const hidden = form.querySelector(`[data-segment-value="${group.dataset.segments}"]`);
      const buttons = Array.from(group.querySelectorAll('[data-segment]'));
      buttons.forEach((btn, idx) => {
        btn.addEventListener('click', () => {
          buttons.forEach((b) => {
            b.classList.toggle('is-selected', b === btn);
            b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
          });
          hidden.value = btn.dataset.segment;
          const rentHint = form.querySelector('[data-rent-hint]');
          if (rentHint && group.dataset.segments === 'Objekt') {
            rentHint.hidden = !btn.hasAttribute('data-segment-rent');
          }
        });
        btn.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') (buttons[idx + 1] || buttons[0]).focus();
          if (e.key === 'ArrowLeft') (buttons[idx - 1] || buttons[buttons.length - 1]).focus();
        });
      });
    });

    // Rückruf: Pills erst nach Aktivierung
    const cbToggle = form.querySelector('[data-callback-toggle]');
    const pills = form.querySelector('[data-callback-pills]');
    const cbValue = form.querySelector('[data-callback-value]');
    if (cbToggle) {
      cbToggle.addEventListener('change', () => {
        pills.hidden = !cbToggle.checked;
        if (!cbToggle.checked) {
          cbValue.value = '';
          pills.querySelectorAll('[data-callback-window]').forEach((p) => {
            p.classList.remove('is-selected');
            p.setAttribute('aria-checked', 'false');
          });
        }
        track('contact_callback_toggle', { aktiv: cbToggle.checked });
      });
      pills.querySelectorAll('[data-callback-window]').forEach((pill) => {
        pill.addEventListener('click', () => {
          pills.querySelectorAll('[data-callback-window]').forEach((p) => {
            p.classList.toggle('is-selected', p === pill);
            p.setAttribute('aria-checked', p === pill ? 'true' : 'false');
          });
          cbValue.value = pill.dataset.callbackWindow;
        });
      });
    }

    form.addEventListener('submit', () => {
      const ref = `RC-${new Date().getFullYear()}-${String(Math.floor(Math.random() * 90000) + 10000)}`;
      sessionStorage.setItem('rc-contact-ref', ref);
      const refField = document.createElement('input');
      refField.type = 'hidden';
      refField.name = 'contact[Referenz]';
      refField.value = ref;
      form.appendChild(refField);
      track('contact_submit', { rueckruf: cbToggle ? cbToggle.checked : false });
    });
  }

  /* ---------- Erfolgszustand: Referenz + Rückmeldezeit ---------- */

  const success = document.querySelector('[data-contact-success]');
  if (success) {
    const ref = sessionStorage.getItem('rc-contact-ref');
    const refEl = success.querySelector('[data-success-ref]');
    if (ref && refEl) refEl.textContent = `${refEl.dataset.label || 'Referenz'}: ${ref}`;
    // Rückmeldezeit: innerhalb der Öffnungszeiten → "heute bis HH:30", sonst nächster Werktag
    const now = new Date();
    const textEl = success.querySelector('[data-success-text]');
    if (textEl && availability) {
      const open = isOpen(hoursMap, holidayList, now);
      const win = hoursMap[now.getDay() === 0 ? 7 : now.getDay()];
      if (open && win) {
        const due = Math.min(now.getHours() + 2, win[1]);
        textEl.textContent += ` ${textEl.dataset.today || 'Rückmeldung heute bis'} ${due}:30 Uhr.`;
      } else {
        textEl.textContent += ` ${textEl.dataset.nextday || 'Rückmeldung am nächsten Werktag.'}`;
      }
    }
    success.scrollIntoView({ block: 'center' });
  }
})();
